document.addEventListener('DOMContentLoaded', () => {
  const videoContainers = document.querySelectorAll('.video-with-thumbnail');

  videoContainers.forEach((container) => {
    const video = container.querySelector('video');

    container.addEventListener('click', () => {
      // Remove 'active' class from all video containers
      videoContainers.forEach((otherContainer) => {
        otherContainer.classList.remove('active');
        const otherVideo = otherContainer.querySelector('video');
        if (otherVideo) {
          otherVideo.pause();
          otherVideo.currentTime = 0; // Reset video
        }
      });

      // Add 'active' class and play the video
      container.classList.add('active');
      video.play();
    });
  });
});
